import { AxiosPromise } from "axios"
import { Invitation } from "models"
import { userApi } from "./api"

export const sendInvitation = (data: Invitation): AxiosPromise =>
  userApi("/send-invitation", {
    data,
    method: "POST"
  })
